import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { TAGS } from "./common/tags";

import { getSubscriptionConfigurationsEndpoint } from "./endpoints";

export const subscriptionApiSlice = createApi({
  reducerPath: "subscriptionApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  tagTypes: [TAGS.SUBSCRIPTION],
  endpoints: (builder) => ({
    ...getSubscriptionConfigurationsEndpoint(builder),
  }),
});

export const { useGetSubscriptionConfigurationsQuery } = subscriptionApiSlice;
